export default function EmailCTA({ className = '' }) {
  return (
    <div className={`flex items-start gap-4 ${className}`}>
      <div className="text-[#5f7365] text-2xl shrink-0 pt-0.5">
        <i className="fa-regular fa-envelope" aria-hidden="true" />
      </div>
      <div className="space-y-1.5 flex-1 min-w-0">
        <div className="text-base sm:text-lg font-semibold text-[#5f7365] truncate">
          <a 
            href="mailto:kontakt@dinprivatpsykolog.dk" 
            className="hover:text-[#5f7365] transition-colors inline-block whitespace-nowrap focus:outline-none focus:underline"
            aria-label="Send e-mail til kontakt@dinprivatpsykolog.dk"
          >
            <span className="whitespace-nowrap">kontakt@dinprivatpsykolog.dk</span>
          </a>
        </div>
        <p className="text-xs text-[#4A5D51]">
          Send gerne en besked om din henvendelse, så vender jeg hurtigt tilbage.
        </p>
      </div>
    </div>
  );
}
